export const LOGOUT="LOGOUT";
export const LOGIN="LOGIN"

export const GOOGLELOGIN="GOOGLELOGIN"

export const ADDDETAIL="ADDDETAIL"